import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import api from '~/services/api';

import CameraUploadMultiple from './components/CameraUploadMultiple';
import * as S from './styles';

export default function FotoNF() {
  const [data, setData] = useState();

  const location = useLocation();

  // const urlParamsTESTE = new URLSearchParams(location.search);

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  const token = urlParams.get('token');

  useEffect(() => {
    const fetchData = async () => {
      const response = await api.get(`fotosnf/descaganf/token/${id}`);
      setData(response?.data);
    };
    fetchData();
  }, [id]);

  return (
    <S.Container>
      <CameraUploadMultiple id={id} token={token} data={data} />
    </S.Container>
  );
}
